import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-6 py-20 md:py-32 bg-background-50">
        <div className="w-full max-w-[600px] mx-auto text-center">
          <p className="font-heading text-[80px] md:text-[120px] leading-none text-primary-500/30 select-none">
            404
          </p>
          <h1 className="mt-4 font-heading text-2xl md:text-3xl text-foreground-950">
            页面不存在
          </h1>
          <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
            你访问的页面可能已被移除，或链接地址有误。
          </p>
          <p className="mt-2 text-xs text-foreground-400 break-all">{location.pathname}</p>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <Link
              to="/"
              className="h-11 px-6 rounded-md bg-primary-500 text-foreground-950 text-sm inline-flex items-center justify-center gap-2 cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/category/popular"
              className="h-11 px-6 rounded-md border border-background-400/60 text-foreground-800 text-sm inline-flex items-center justify-center gap-2 cursor-pointer hover:border-accent-500 hover:text-accent-500 transition-colors whitespace-nowrap"
            >
              浏览热门影片
            </Link>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}